<template>
  <div class="tradingview-chart">
    <div id="fund_tradingview_chart_container" :class="[getOS == 'ios' ? 'ios' : '']"></div>
  </div>
</template>

<script>
require("../../../assets/vendor/tradingview/charting_library.min.js");
import Datafeeds from "../../../assets/vendor/tradingview/datafeed/udf/fundDatafeed";

export default {
  name: "fund-tradingview-chart",
  metaInfo() {
    return {
      title: process.env.VUE_APP_NAME
    };
  },
  props: {
    // Props to receive
    mode: {
      type: String,
      default: "simply"
    },
    name: {
      type: String,
      required: true,
      default: ""
    },
    showChartCover: {
      type: Boolean,
      default: true
    },
    tradingviewConfig: {
      // eslint-disable-next-line no-unused-vars
      validator: Obj => {
        return true;
      },
      default: () => {
        return {
          // "type": "black" | "white",
          fullscreen: false,
          timeframe: "1Y",
          // "symbol":"",
          interval: "D",
          // "resolution": "1Y",
          container_id: "fund_tradingview_chart_container",
          datafeed: new Datafeeds.UDFCompatibleDatafeed("/api/fund"),
          library_path: "/vendor/tradingview/",
          locale: "en",
          timezone: "Asia/Bangkok",
          autosize: true,
          // height: "300px",
          // "drawings_access": { type: 'black', tools: [ { name: "Regression Trend",
          //     grayed: true }, { name: "MACD",
          //     grayed: true }, { name: "Relative Strength Index",
          //     grayed: true } ] },
          // "disabled_features": ["use_localstorage_for_settings", "header_symbol_search","left_toolbar","timeframes_toolbar","legend_context_menu","scales_context_menu","display_market_status","header_widget"],
          // '1D', '1W', '1M', '3M', '6M', '1Y', '3Y','5Y','10Y', 'SI', 'YTD'
          time_frames: [
            { text: "1d", resolution: "D", description: "1 DAY", title: "1d" },
            { text: "7d", resolution: "D", description: "7 DAYS", title: "7d" },
            {
              text: "1m",
              resolution: "D",
              description: "1 MONTHS",
              title: "1m"
            },
            {
              text: "3m",
              resolution: "D",
              description: "3 MONTHS",
              title: "3m"
            },
            {
              text: "6m",
              resolution: "D",
              description: "6 MONTHS",
              title: "6m"
            },
            {
              text: "1y",
              resolution: "D",
              description: "1 Years",
              title: "1y"
            },
            {
              text: "3y",
              resolution: "D",
              description: "3 Years",
              title: "3y"
            },
            {
              text: "5y",
              resolution: "D",
              description: "5 Years",
              title: "5y"
            },
            {
              text: "10y",
              resolution: "D",
              description: "10 Years",
              title: "10y"
            },
            { text: "1000y", resolution: "D", description: "All", title: "All" }
          ],
          drawings_access: { type: "black", tools: [{ name: "Trend Line" }] },
          // disabled_features: ["use_localstorage_for_settings", "volume_force_overlay"],
          enabled_features: ["move_logo_to_main_pane"],
          overrides: {
            // "paneProperties.background": "#000000",
            "mainSeriesProperties.style": 8,
            "mainSeriesProperties.areaStyle.color1": "#f5f9fd",
            "mainSeriesProperties.areaStyle.color2": "#f5f9fd",
            "mainSeriesProperties.areaStyle.linecolor": "#4c99ec",
            "mainSeriesProperties.areaStyle.linestyle": 1,
            "mainSeriesProperties.areaStyle.linewidth": 2,
            "mainSeriesProperties.areaStyle.priceSource": "high",
            "symbolWatermarkProperties.color": "rgba(0,0,0,0.1)",
            volumePaneSize: "tiny",
            "mainSeriesProperties.leftAxisProperties.autoScale": true,
            "paneProperties.leftAxisProperties.autoScaleDisabled": true,
            "paneProperties.topMargin": 10,
            "paneProperties.bottomMargin": 10,
            "timeScale.rightOffset": 0,
            "timeScale.leftOffset": 0,
            "scalesProperties.showLeftScale": false,
            "scalesProperties.showRightScale": true,
            "scalesProperties.backgroundColor": "#ffffff",
            "scalesProperties.fontSize": 11,
            // right border
            "scalesProperties.lineColor": "#555",
            "scalesProperties.textColor": "#555",
            "scalesProperties.scaleSeriesOnly": true,
            "scalesProperties.showSeriesLastValue": true,
            "scalesProperties.showSeriesPrevCloseValue": true,
            "scalesProperties.showStudyLastValue": true,
            "scalesProperties.showStudyPlotLabels": true,
            "scalesProperties.showSymbolLabels": false
          },
          studies_overrides: {
            // "volume.volume.color.0": "#00FFFF",
            // "volume.volume.color.1": "#0000FF",
            // "volume.volume.transparency": 70,
            // "volume.volume ma.color": "#FF0000",
            // "volume.volume ma.transparency": 30,
            // "volume.volume ma.linewidth": 5,
            // "volume.show ma": true,
            // "bollinger bands.median.color": "#33FF88",
            // "bollinger bands.upper.linewidth": 7
          },
          debug: false,
          favorites: {
            // intervals: ["1D", "3D", "3W", "1W", "1M"],
            chartTypes: ["Area", "Line"]
          }
          // charts studies feature >>>
          // enabled_features: ["study_templates"],
          // charts_storage_url: 'http://saveload.tradingview.com',
          // charts_storage_api_version: "1.1",
          // client_id: 'tradingview.com',
          // user_id: 'public_user_id'
          // <<<
        };
      }
    }
  },
  data: () => ({
    tv: null,
    lang: "en"
  }),
  watch: {
    name() {
      this.tv.setSymbol(this.name, this.tv.chart().resolution(), null);
      return this.name;
    }
  },
  methods: {
    getParameterByName() {
      let name = "lang";
      // eslint-disable-next-line no-useless-escape
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");

      var results = null;
      if (typeof location != "undefined") results = regex.exec(location.search);
      this.lang = results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
  },
  computed: {
    getOS() {
      return this.$liff.getOS();
    }
  },
  created() {
    this.$store.commit("global/SET_SHOW_FOOTER", false);
  },
  mounted() {
    setTimeout(() => {
      if (this.mode == "simply") {
        this.tradingviewConfig.disabled_features = [
          "use_localstorage_for_settings",
          "header_symbol_search",
          "left_toolbar",
          // "timeframes_toolbar",
          "legend_context_menu",
          "scales_context_menu",
          "display_market_status",
          "header_widget"
        ];
      } else if (this.mode == "advanced") {
        this.tradingviewConfig.disabled_features = [
          "use_localstorage_for_settings",
          "header_symbol_search"
        ];
      }
      //FIX SCREEN POSITION
      var metaTag = document.createElement("meta");
      metaTag.name = "viewport";
      metaTag.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0";
      document.getElementsByTagName("head")[0].appendChild(metaTag);
      let tradingviewConfig = this.tradingviewConfig;
      tradingviewConfig.symbol = this.name;
      tradingviewConfig.locale = this.getParameterByName() || "en";
      // eslint-disable-next-line no-undef
      let widget = new TradingView.widget(tradingviewConfig);
      widget.onChartReady(function() {});
      this.tv = widget;
    }, 500);
  },
  destroyed() {
    this.$store.commit("global/SET_SHOW_FOOTER", true);
  }
};
</script>
<style lang='scss' scoped>
.tradingview-chart {
  padding: 0;
  #fund_tradingview_chart_container {
    z-index: 10;
    height: 100vh;
  }
  .ios {
    @include manageiPhoneMedia;
  }
}

.chart-cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0px;
  background-color: black;
  opacity: 0.8;
}

.chart-cover-text {
  top: 50%;
  transform: translateY(-50%);
  position: relative;
  opacity: 1;
  color: white;
  font-size: 40px;
  text-align: center;
  padding: 0px 10px 0px 10px;
}
</style>

